<template>
  <DefaultLayout
    menuIndex="/instructions/instructionsList"
    openeds="instructions"
  >

    <div class="page-header">
      <div class="page-header-left">
        <el-input
          v-model="searchForm.name"
          placeholder="请输入名称，支持模糊搜索"
          style="margin-right: 5px; width: 300px;"
        />
        <el-button
          type="primary"
          @click="onSearch"
          :icon="Search"
        ></el-button>
      </div>
      <div></div>
    </div>

    <div style="padding: 20px">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="名称"
          :resizable="false"
        />
        <el-table-column
          prop="remark"
          label="备注"
          :resizable="false"
        />
        <el-table-column
          label="二维码"
          :resizable="false"
          width="130"
        >
          <template #default="scope">
            <vueQr
              :callback="qrBack"
              :text="scope.row.url"
              :size="100"
              :logoSrc="logoSrc"
              :qid="scope.row.id.toString()"
            ></vueQr>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          class-name="operate"
          width="150"
        >
          <template #default="scope">
            <el-button
              :icon="Edit"
              @click="handleEdit(scope.$index, scope.row)"
            ></el-button>
            <el-button
              type="primary"
              :icon="Download"
              @click="handleDownQr(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </DefaultLayout>
</template>

<script>
export default {
  name: 'InstructionsListPage'
}
</script>

<script setup>
import DefaultLayout from '../../components/layout/DefaultLayout.vue'
import router from '../../router'
import {
  Edit,
  Download,
  Search
} from '@element-plus/icons-vue'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { reactive, ref, onMounted } from 'vue'
import { QrCode } from '@/api/request'

const searchForm = reactive({
  name: ''
})

const tableData = ref([
  // {
  //   name: '专机操作手册',
  //   remark: '你好早上好见到你很高兴再见',
  //   url: 'https://element-plus.org/zh-CN/component/button.html',
  //   id: '1'
  // }
])

const qrData = reactive({})
const logoSrc = ''

onMounted(() => {
  //请求二维码信息列表
  QrCode.GetList(true, 1, 500, 1, null).then((res) => {
    // console.log(res.content)
    const result = []
    if (res.content) {
      for (const ele of res.content) {
        result.push({
          id: ele.id,
          name: ele.title,
          remark: ele.intro,
          url: `https://www.zs-tek.com/help.html?id=${ele.id}`,
          videoUrl: ele.video,
          specificationUrl: ele.specification
        })
      }
    }
    tableData.value = result
  })
})

const onSearch = () => {
  console.log(searchForm.name)
  //搜索二维码信息列表
  QrCode.GetList(true, 1, 500, 1, searchForm.name ? searchForm.name : null).then((res) => {
    // console.log(res.content)
    const result = []
    if (res.content) {
      for (const ele of res.content) {
        result.push({
          id: ele.id,
          name: ele.title,
          remark: ele.intro,
          url: `https://www.zs-tek.com/help.html?id=${ele.id}`,
          videoUrl: ele.video,
          specificationUrl: ele.specification
        })
      }
    }
    tableData.value = result
  })
}

const handleEdit = (index, row) => {
  // router.push(`/instructions/editQR/${row.id}`);
  router.push({
    path: '/instructions/editQR',
    //这里直接传一个item，item就是一个对象
    // query:item
    //你也可以这样写 二选一
    query: {
      id: row.id
    }
  })
}

const handleDownQr = (index, row) => {
  let name = row.name;
  let a = document.createElement("a");
  a.style.display = "none";
  a.download = name;
  a.href = qrData[row.id];
  document.body.appendChild(a);
  a.click();
}

const qrBack = (dataUrl, id) => {
  qrData[id] = dataUrl
}

</script>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.page-header-left {
  display: flex;
}
</style>
